import React from "react";
import { Body1 } from "@activecollab/components";
import PropTypes from "prop-types";
import TaskListItemContainer from "../container.task_list_item.jsx";

const TaskDependencies = ({ headerText, tasks, taskId, showConflict }) => {
  return (
    <div>
      <Body1
        weight="bold"
        className="tw-mb-2"
      >
        {headerText}
      </Body1>
      <div
        className="task_list"
        data-qa-id="list-of-all-tasks"
      >
        <div className="tasks">
          {tasks.map((id) => (
            <div key={id}>
              <TaskListItemContainer
                id={id}
                isDependency
                taskDependencyId={taskId}
                showConflict={showConflict}
                showTooltip
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

TaskDependencies.propTypes = {
  headerText: PropTypes.string,
  tasks: PropTypes.array,
  showConflict: PropTypes.bool,
  taskId: PropTypes.number,
};

TaskDependencies.defaultProps = {
  showConflict: false,
};

TaskDependencies.displayName = `TaskDependencies`;

export default TaskDependencies;
